import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { inicioSucursalData } from 'app/mock-api/inicio-sucursal/data';
import { cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root',
})
export class InicioSucursalMockApi {
    private _data: any = cloneDeep(inicioSucursalData);

    constructor(private _fuseMockApiService: FuseMockApiService) {
        this.registerHandlers();
    }

    registerHandlers(): void {
        this._fuseMockApiService
            .onGet('api/inicio-sucursal/dashboard')
            .reply(() => [200, cloneDeep(this._data)]);

        this._fuseMockApiService
            .onGet('api/inicio-sucursal/checklist-apertura')
            .reply(({ request }) => {
                const tipo = request.params.get('tipo');
                const checklist = tipo === 'LIMPIEZA' ? this._data.limpieza : this._data.checklistApertura;
                return [200, cloneDeep(checklist)];
            });

        this._fuseMockApiService
            .onPost('api/inicio-sucursal/checklist-apertura')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                const checklist = body.tipo === 'LIMPIEZA' ? this._data.limpieza : this._data.checklistApertura;
                if (!checklist.id) {
                    const newId = Math.floor(Math.random() * 10000) + 5000;
                    checklist.id = newId;
                }
                if (body.items) {
                    checklist.items = body.items;
                }
                return [200, cloneDeep(checklist)];
            });

        this._fuseMockApiService
            .onPut('api/inicio-sucursal/checklist-apertura/:id/toggle/:item')
            .reply(({ request, urlParams }) => {
                const item = decodeURIComponent(urlParams['item'] || '');
                const checklistList = [this._data.checklistApertura, this._data.limpieza];
                const checklist = checklistList.find((c: any) => c.id === +urlParams['id']);
                if (!checklist) {
                    return [404, { message: 'Checklist not found' }];
                }
                if (checklist.itemsCompletados.includes(item)) {
                    checklist.itemsCompletados = checklist.itemsCompletados.filter((i: string) => i !== item);
                } else {
                    checklist.itemsCompletados = [...checklist.itemsCompletados, item];
                }
                return [200, cloneDeep(checklist)];
            });

        this._fuseMockApiService
            .onPut('api/inicio-sucursal/checklist-apertura/:id/finalizar')
            .reply(({ urlParams }) => {
                const checklistList = [this._data.checklistApertura, this._data.limpieza];
                const checklist = checklistList.find((c: any) => c.id === +urlParams['id']);
                if (!checklist) {
                    return [404, { message: 'Checklist not found' }];
                }
                checklist.completado = true;
                checklist.completadoEn = new Date().toISOString();
                return [200, cloneDeep(checklist)];
            });

        this._fuseMockApiService
            .onPost('api/inicio-sucursal/notas')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                const newNota = {
                    id: Math.floor(Math.random() * 10000) + 2000,
                    empleadoId: this._data.empleado.id,
                    empleadoNombre: this._data.empleado.nombre,
                    empleadoFoto: this._data.empleado.foto || '',
                    contenido: body.contenido,
                    importante: body.importante || false,
                    leidoPor: [this._data.empleado.id],
                    createdAt: new Date().toISOString(),
                };
                this._data.notas = [newNota, ...this._data.notas];
                return [200, cloneDeep(newNota)];
            });

        this._fuseMockApiService
            .onDelete('api/inicio-sucursal/notas/:id')
            .reply(({ urlParams }) => {
                const id = +urlParams['id'];
                this._data.notas = this._data.notas.filter((n: any) => n.id !== id);
                return [200, {}];
            });

        this._fuseMockApiService
            .onPut('api/inicio-sucursal/notas/:id/marcar-leida')
            .reply(({ urlParams }) => {
                const id = +urlParams['id'];
                const nota = this._data.notas.find((n: any) => n.id === id);
                if (nota && !nota.leidoPor.includes(this._data.empleado.id)) {
                    nota.leidoPor = [...nota.leidoPor, this._data.empleado.id];
                }
                return [200, {}];
            });

        this._fuseMockApiService
            .onPut('api/inicio-sucursal/notas/:id/pin')
            .reply(({ urlParams }) => {
                const id = +urlParams['id'];
                const nota = this._data.notas.find((n: any) => n.id === id);
                if (nota) {
                    nota.importante = !nota.importante;
                }
                return [200, cloneDeep(nota)];
            });

        this._fuseMockApiService
            .onGet('api/inicio-sucursal/lentes-entregar')
            .reply(() => [200, cloneDeep(this._data.lentesParaEntregar)]);

        this._fuseMockApiService
            .onGet('api/inicio-sucursal/contactos-pendientes')
            .reply(() => [200, cloneDeep(this._data.contactosPendientes)]);

        this._fuseMockApiService
            .onGet('api/inicio-sucursal/config-widgets')
            .reply(() => [200, {
                widgetsVisibles: this._data.widgetsVisibles,
                ordenWidgets: this._data.ordenWidgets,
                atajosRapidos: this._data.atajosRapidos,
            }]);

        this._fuseMockApiService
            .onPut('api/inicio-sucursal/config-widgets')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                if (body.widgetsVisibles) {
                    this._data.widgetsVisibles = body.widgetsVisibles;
                }
                if (body.ordenWidgets) {
                    this._data.ordenWidgets = body.ordenWidgets;
                }
                if (body.atajosRapidos) {
                    this._data.atajosRapidos = body.atajosRapidos;
                }
                return [200, {
                    widgetsVisibles: this._data.widgetsVisibles,
                    ordenWidgets: this._data.ordenWidgets,
                    atajosRapidos: this._data.atajosRapidos,
                }];
            });

        this._fuseMockApiService
            .onPost('api/inicio-sucursal/config-widgets/atajo')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                const newAtajo = {
                    label: body.label,
                    icono: body.icono || 'heroicons_outline:star',
                    ruta: body.ruta,
                };
                this._data.atajosRapidos = [...this._data.atajosRapidos, newAtajo];
                return [200, cloneDeep(newAtajo)];
            });

        this._fuseMockApiService
            .onDelete('api/inicio-sucursal/config-widgets/atajo/:index')
            .reply(({ urlParams }) => {
                const index = +urlParams['index'];
                if (index >= 0 && index < this._data.atajosRapidos.length) {
                    this._data.atajosRapidos.splice(index, 1);
                    this._data.atajosRapidos = [...this._data.atajosRapidos];
                }
                return [200, {}];
            });

        this._fuseMockApiService
            .onPost('api/inicio-sucursal/caja/aperturar')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                this._data.caja = {
                    aperturada: true,
                    montoInicial: body.montoInicial || 2000,
                    montoActual: body.montoInicial || 2000,
                    responsable: this._data.empleado.nombre,
                    horaApertura: new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
                };
                return [200, cloneDeep(this._data.caja)];
            });

        // ===== Reloj checador (Asistencia RH) =====
        this._fuseMockApiService
            .onGet('api/rh/asistencia/hoy/:empleadoId')
            .reply(() => {
                if (!this._data.asistenciaHoy) {
                    return [200, null];
                }
                // Si ya tiene salida, mantenla; en caso contrario, simular avance cada vez
                // que se consulta (sólo para que el "tiempo trabajado" se actualice).
                return [200, cloneDeep(this._data.asistenciaHoy)];
            });

        this._fuseMockApiService
            .onPost('api/rh/asistencia/check-in')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                if (this._data.asistenciaHoy?.horaEntrada) {
                    return [400, { message: 'Ya realizaste tu entrada hoy' }];
                }
                const ahora = new Date();
                this._data.asistenciaHoy = {
                    id: this._data.asistenciaHoy?.id || 9001,
                    empleadoId: body.empleadoId || this._data.empleado.id,
                    fecha: ahora.toISOString().split('T')[0],
                    horaEntrada: ahora.toISOString(),
                    horaSalida: null,
                    tipoEntrada: body.tipo || 'MANUAL',
                    tipoSalida: null,
                    // Simulación de tardanza: si la hora actual es >= 09:15, marcamos TARDANZA
                    estado: ahora.getHours() >= 9 && ahora.getMinutes() >= 15 ? 'TARDANZA' : 'PUNTUAL',
                    turnoId: 5,
                };
                return [200, cloneDeep(this._data.asistenciaHoy)];
            });

        this._fuseMockApiService
            .onPost('api/rh/asistencia/check-out')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                if (!this._data.asistenciaHoy?.horaEntrada) {
                    return [400, { message: 'No tienes registro de entrada hoy' }];
                }
                if (this._data.asistenciaHoy.horaSalida) {
                    return [400, { message: 'Ya realizaste tu salida hoy' }];
                }
                if (this._data.asistenciaHoy.horaSalidaComida && !this._data.asistenciaHoy.horaRegresoComida) {
                    return [400, { message: 'Estás en comida. Registra primero el regreso de comida.' }];
                }
                this._data.asistenciaHoy = {
                    ...this._data.asistenciaHoy,
                    horaSalida: new Date().toISOString(),
                    tipoSalida: body.tipo || 'MANUAL',
                };
                return [200, cloneDeep(this._data.asistenciaHoy)];
            });

        this._fuseMockApiService
            .onPost('api/rh/asistencia/salida-comida')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                if (!this._data.asistenciaHoy?.horaEntrada) {
                    return [400, { message: 'Debes registrar tu entrada antes de salir a comer' }];
                }
                if (this._data.asistenciaHoy.horaSalidaComida) {
                    return [400, { message: 'Ya registraste tu salida a comer hoy' }];
                }
                if (this._data.asistenciaHoy.horaSalida) {
                    return [400, { message: 'Ya finalizaste tu jornada, no puedes salir a comer' }];
                }
                this._data.asistenciaHoy = {
                    ...this._data.asistenciaHoy,
                    horaSalidaComida: new Date().toISOString(),
                    tipoSalidaComida: body.tipo || 'MANUAL',
                };
                return [200, cloneDeep(this._data.asistenciaHoy)];
            });

        this._fuseMockApiService
            .onPost('api/rh/asistencia/regreso-comida')
            .reply(({ request }) => {
                const body = JSON.parse(request.body || '{}');
                if (!this._data.asistenciaHoy?.horaSalidaComida) {
                    return [400, { message: 'No tienes salida a comer registrada' }];
                }
                if (this._data.asistenciaHoy.horaRegresoComida) {
                    return [400, { message: 'Ya regresaste de comer' }];
                }
                if (this._data.asistenciaHoy.horaSalida) {
                    return [400, { message: 'Ya finalizaste tu jornada' }];
                }
                this._data.asistenciaHoy = {
                    ...this._data.asistenciaHoy,
                    horaRegresoComida: new Date().toISOString(),
                    tipoRegresoComida: body.tipo || 'MANUAL',
                };
                return [200, cloneDeep(this._data.asistenciaHoy)];
            });
    }
}
